import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { Tradeline } from '@/types/unlock'

/**
 * Tradeline is a mixed entity that takes Financing (Liens) and Payoffs
 */
export const tradelineApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTradelineByExternalId: builder.query<Tradeline, string>({
      query: (externalId) => `v1/tradeline/${externalId}/`,
    }),

    createTradeline: builder.mutation<Tradeline, Partial<Tradeline>>({
      query: (body) => ({
        method: 'POST',
        url: 'v1/tradeline/',
        body,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'Tradeline',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'MaxActions',
        'Alert',
        'Declaration',
        'SubscriberV2',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationCalcs']))
      },
    }),

    updateTradeline: builder.mutation<Tradeline, Partial<Tradeline>>({
      query: (body) => ({
        method: 'PATCH',
        url: `v1/tradeline/${body.external_id}/`,
        body,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'Tradeline',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'AutomatedApplicationExceptions',
        'Declaration',
        'MaxActions',
        'ApplicationExceptions',
        'Escalations',
        'Alert',
        'SubscriberV2',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationCalcs']))
      },
    }),

    deleteTradeline: builder.mutation<Tradeline, Partial<Tradeline>>({
      query: (body) => ({
        method: 'DELETE',
        url: `v1/tradeline/${body.external_id}/`,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'Tradeline',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'MaxActions',
        'Alert',
        'Declaration',
        'SubscriberV2',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationCalcs']))
      },
    }),
  }),
})

export const {
  useGetTradelineByExternalIdQuery,
  useCreateTradelineMutation,
  useUpdateTradelineMutation,
  useDeleteTradelineMutation,
} = tradelineApi
